/*
* This code is the intellectual property of Bulb Inc. and other software publishers.
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import {
  Component, EventEmitter, Input, Output, TemplateRef, ViewChild,
} from '@angular/core';

import { OverlayPanel } from 'primeng/overlaypanel';
import { ColorOptions, MenuItem, MenuItemClickEvent } from '../types';

@Component({
  selector: 'bulb-menu-list',
  templateUrl: './menu-list.component.html',
  styleUrls: ['./menu-list.component.scss'],
  standalone: false,
})
export class MenuListComponent {
  public ColorOptions = ColorOptions;

  // The footer template passed in from the parent component.
  @Input() footerTemplate: TemplateRef<any>;

  @Input() menuItems: Array<MenuItem>;

  /**
   * Event emitter for menu items when clicked.
   */
  @Output() menuItemClicked: EventEmitter<MenuItemClickEvent> = new EventEmitter<MenuItemClickEvent>();

  @ViewChild('overlayPanel') overlayPanel: OverlayPanel;

  public toggle(event: Event): void {
    this.overlayPanel.show(event);
  }
}
